import { Component, OnInit, ChangeDetectionStrategy, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'fal-expander',
  templateUrl: './expander.component.html',
  styleUrls: ['./expander.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpanderComponent implements OnInit {
  @Input() items!: string[];
  private _expanderExpanded = false;
  @Input() public get expanderExpanded(): boolean {
    return this._expanderExpanded;
  }
  public set expanderExpanded(value: boolean) {
    this._expanderExpanded = value;
    if (this._expanderExpanded === false) {
      this.expander.nativeElement.scrollTop = 0;
    }
  }
  @ViewChild('expander') private expander!: ElementRef<HTMLElement>;
  private alignments: string[] = new Array<string>();

  ngOnInit(): void {
    let counter = 0;
    for (let i = 0; i < this.items.length; i++) {
      if (counter === 0) this.alignments.push('start');
      else if (counter === 1 || counter === 2) this.alignments.push('center');
      else {
        this.alignments.push('end');
        counter = 0;
        continue;
      }
      counter++;
    }
  }

  getTextAlign(index: number): string {
    return this.alignments[index];
  }
}
